import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import { userState } from '../../store';

interface Tab {
  label: string;
  emoji: string;
  path: string;
  requiresAuth?: boolean;
}

const tabs: Tab[] = [
  { label: 'Zápasy',  emoji: '⚽', path: '/' },
  { label: 'Tabulka', emoji: '🏆', path: '/zebricek' },
  { label: 'Bonus',   emoji: '🎯', path: '/uzivatel/bonusova-otazka', requiresAuth: true },
  { label: 'Profil',  emoji: '👤', path: '/uzivatel/profil/muj-profil', requiresAuth: true },
];

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const snap = useSnapshot(userState);

  const visibleTabs = tabs.filter(t => !t.requiresAuth || snap.isLoggedIn);

  return (
    <nav className="sm:hidden fixed bottom-0 inset-x-0 z-50 bg-bg-card border-t border-border-muted h-[70px] flex items-stretch">
      {visibleTabs.map(tab => {
        const isActive = location.pathname === tab.path ||
          (tab.path !== '/' && location.pathname.startsWith(tab.path));

        return (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            className={[
              'relative flex-1 flex flex-col items-center justify-center gap-0.5 transition-colors duration-150',
              'font-nunito text-[11px] font-extrabold uppercase tracking-wide',
              isActive ? 'text-brand-blue' : 'text-text-muted',
            ].join(' ')}
          >
            <span className="text-[20px] leading-none">{tab.emoji}</span>
            <span>{tab.label}</span>
            {/* Active underline pill */}
            {isActive && (
              <div className="absolute bottom-1 w-[18px] h-[3px] bg-brand-blue rounded-full" />
            )}
          </button>
        );
      })}
    </nav>
  );
}
